// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"902":"c5876da1","924":"9b4ada78"}[chunkId] + ".chunk.css";
};